import { useFeatureFlags } from 'utils/features';

export default function useIsPro() {
  return useFeatureFlags('PRO');
}
